// Config git credential helper dùng gh token. Cần thiết để `git ls-remote`,
// `git clone`, `git push` qua HTTPS hoạt động khi gh đã auth nhưng git chưa
// biết về token đó. Idempotent — chạy nhiều lần OK.
import { spawnSync } from "node:child_process";
import { log } from "./terminal-logger.js";

export function setupGitCredentialViaGh(): void {
  const r = spawnSync("gh", ["auth", "setup-git"], { stdio: "ignore" });
  if (r.status !== 0) {
    // Không throw — nếu setup-git fail, git operation sau có thể vẫn work
    // (vd user đã có credential helper khác). Chỉ warn.
    log.warn("gh auth setup-git fail (non-fatal). Nếu git clone lỗi 128 → chạy thủ công.");
    return;
  }
  log.dim("Git credential helper đã link với gh token.");
}
